import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router';
import './dashboard.scss';
import EyeTestImg from '../../Assets/Img/AdobeStock_6723704.jpeg';
import PatientImg from '../../Assets/Img/AdobeStock_622744253.jpeg';
import testCardImg from '../../Assets/Img/testCardImg.png';
import patientCardImg from '../../Assets/Img/patientCardImg.png';
import { useSelector } from 'react-redux';
import { usePatientCountMutation } from '../Patient/patientApi';
import { useEyetestCountMutation } from '../Eyetest/eyetestApi';
import { useTranslation } from 'react-i18next';
import Notification from './notification';
import RecentTestCard from './recentTestCard';
import LoadingComponent from '../LoadingComponent';
import { ProductFruits } from 'react-product-fruits';
import WhatsNew from './whatsNew';
import WhatsNew2 from './whatsNewtext';
import { LineChart } from './line-chart';
import OrdersCount from './ordersCount';
import TestDetails from './testDetails';
import { getSecureItem } from "../../utils/secureStorage";
const Dashboard = () => {
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    console.log(user, 'useruseruser');

    const userInfo = {
        username: user?.email,
        email: user?.email,
        firstname: user?.name,
        lastname: user?.lastName,
        signUpAt: '',
        role: user?.userType,
        props: { customProp1: user?.isExternal },
    };

    const patientCount = useSelector((state) => state.patient);
    const eyetestCount = useSelector((state) => state.eyetest);
    const navigate = useNavigate();
    const [patientNumber] = usePatientCountMutation();
    const [eyetestNumber] = useEyetestCountMutation();
    const totalEyetests = eyetestCount.count[2];
    const doctortotalEyetests = eyetestCount.count[4];

    const config = {
        eyeTestId: '',
        patientEmail: '',
        status: 'Approved,Not Approved,All,Unassigned,Assigned',
        search: '',
        latestRecords: 0,
        pageSize: 0,
        pageNumber: 0,
        startDate: '',
        endDate: '',
        assigUnassigned: '',
    };

    useEffect(() => {
        (async () => {
            if (loading) {
                await patientNumber();
                await eyetestNumber(config);
                setLoading(false);
            }
        })();
    }, [loading]);

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <div className="dashboard_wrapper">
                <Container fluid>
                    <Row>
                        <Col md={8}>
                            <div>
                                <Row>
                                    {user?.userType == 'PATIENT' && (
                                        <RecentTestCard />
                                    )}
                                    {[
                                        'OPTICIAN',
                                        'BACKOFFICE',
                                        'ADMIN',
                                    ].includes(user?.userType) && (
                                            <Col md={6} className="mb-4">
                                                <Card
                                                    className="hoverMintBg"
                                                    style={{
                                                        cursor: 'pointer',
                                                        height: '100%',
                                                    }}
                                                    onClick={() =>
                                                        navigate('/patient/list')
                                                    }
                                                >
                                                    <Card.Header className="d-flex justify-content-between align-items-center bg-transparent">
                                                        <div className="d-flex gap-2">
                                                            <div className="d-flex align-items-center justify-content-center cardImgContainer">
                                                                <img
                                                                    src={
                                                                        patientCardImg
                                                                    }
                                                                    style={{
                                                                        height: '20px',
                                                                    }}
                                                                />
                                                            </div>
                                                            <Card.Title className="mb-0 d-flex align-items-center">
                                                                {t('patients')}
                                                            </Card.Title>
                                                        </div>
                                                        <h2 className="display-6 fw-bold mb-0">
                                                            {patientCount.count}
                                                        </h2>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <Card.Img
                                                            variant="top"
                                                            src={PatientImg}
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )}
                                    <Col
                                        md={
                                            user?.userType == 'EYEDOCTOR'
                                                ? 12
                                                : 6
                                        }
                                        className="mb-4"
                                    >
                                        <Card
                                            className="hoverMintBg"
                                            style={{
                                                cursor: 'pointer',
                                                height: '100%',
                                            }}
                                            onClick={() =>
                                                navigate('/eyetest/list', {
                                                    state: {
                                                        status:
                                                            user?.userType ==
                                                                'EYEDOCTOR'
                                                                ? 'pendingValidation'
                                                                : '',
                                                    },
                                                })
                                            }
                                        >
                                            <Card.Header className="d-flex justify-content-between align-items-center bg-transparent">
                                                <div className="d-flex gap-2">
                                                    <div className="d-flex align-items-center justify-content-center cardImgContainer">
                                                        <img
                                                            src={testCardImg}
                                                            style={{
                                                                height: '20px',
                                                            }}
                                                        />
                                                    </div>
                                                    <Card.Title className="mb-0 d-flex align-items-center">
                                                        {user?.userType ==
                                                            'EYEDOCTOR'
                                                            ? t(
                                                                'Tests en attente de validation'
                                                            )
                                                            : t('totalTests')}
                                                    </Card.Title>
                                                </div>
                                                <h2 className="display-6 fw-bold mb-0">
                                                    {user?.userType ==
                                                        'EYEDOCTOR'
                                                        ? doctortotalEyetests
                                                        : totalEyetests}
                                                </h2>
                                            </Card.Header>
                                            <Card.Body>
                                                {user?.userType ==
                                                    'EYEDOCTOR' ? (
                                                    <LineChart />
                                                ) : (
                                                    <Card.Img
                                                        variant="top"
                                                        src={EyeTestImg}
                                                    />
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                {user?.userType !== 'PATIENT' && (
                                    <>
                                        <TestDetails />
                                        {/* <Card className="mb-4">
                                            <Card.Header className="bg-white d-flex align-items-center" style={{ height: '50px' }}>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="cardImgContainer d-flex align-items-center justify-content-center">
                                                        <img src={visionTestCardImg} style={{ height: '20px' }} />
                                                    </div>
                                                    <Card.Title className="mb-0">{t("visionTest")}</Card.Title>
                                                </div>
                                            </Card.Header>
                                            <Card.Body>

                                                <Row>
                                                    <Col md={6} className="d-flex align-items-center justify-content-center">
                                                        <DonutChart values={piechartValues} />
                                                    </Col>
                                                    <Col md={6} className="d-flex align-items-center">
                                                        <div style={{ width: '100%' }} className="piechart_text">
                                                            <div className="d-flex justify-content-between mb-3 align-items-center" role="button" onClick={() => navigate('/eyetest/list')}>
                                                                <h3>{user?.userType == "EYEDOCTOR" ? t("Tests en attente de validation") : t("total")}</h3><h3>{user?.userType == "EYEDOCTOR" ? totalEyetests : totalEyetests}</h3>
                                                            </div>

                                                            {["OPTICIAN", "BACKOFFICE", "ADMIN"].includes(user?.userType) ? (
                                                                <>
                                                                    <div className="d-flex justify-content-between mb-3" role="button" onClick={() => navigate('/eyetest/list', { state: { status: "approved" } })}>
                                                                        <p className="m-0" style={{ color: "#072CAB" }}>{t("approveds")}</p><h5 className="m-0">{approvedEyetests}</h5>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mb-3" role="button" onClick={() => navigate('/eyetest/list', { state: { status: "pendingValidation" } })}>
                                                                        <p className="m-0" style={{ color: "#6C8CF9" }}>{t("pendingValidation")}</p><h5 className="m-0">{pendingValidationEyetests}</h5>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between" role="button" onClick={() => navigate('/eyetest/list', { state: { status: "unassigned" } })}>
                                                                        <p className="m-0" style={{ color: "#888b8f" }}>{t("unassigned")}</p>
                                                                        <h5 className="m-0">{unassignedEyetests}</h5>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="d-flex justify-content-between mb-3" role="button" onClick={() => navigate('/eyetest/list', { state: { status: "assigned" } })}>
                                                                        <p className="m-0" style={{ color: "#072CAB" }}>Nouveau tests de vue </p><h5 className="m-0">{assignedEyetests}</h5>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mb-3" role="button" onClick={() => navigate('/eyetest/list', { state: { status: "notApproved" } })}>
                                                                        <p className="m-0" style={{ color: "#072CAB" }}>Tests refusés</p><h5 className="m-0">{eyetestCount.count[1]}</h5>
                                                                    </div>
                                                                </>
                                                            )}


                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card> */}
                                    </>
                                )}
                                {user?.userType == 'PATIENT' && (
                                    <>
                                        <Card className="mb-4 recommandations_points">
                                            <Card.Header
                                                className="d-flex justify-content-between align-items-center bg-transparent"
                                                style={{ height: '50px' }}
                                            >
                                                <div className="d-flex gap-2">
                                                    <div className="d-flex align-items-center justify-content-center cardImgContainer">
                                                        <img
                                                            src={testCardImg}
                                                            style={{
                                                                height: '20px',
                                                            }}
                                                        />
                                                    </div>
                                                    <Card.Title className="mb-0 d-flex align-items-center">
                                                        {t('recommandations')}
                                                    </Card.Title>
                                                </div>
                                            </Card.Header>
                                            <Card.Body>
                                                {/* <h4 className="mb-3">Conseils</h4> */}
                                                <ul>
                                                    <li>
                                                        Protégez vos yeux avec
                                                        un filtre anti-lumière
                                                        bleue : il réduit
                                                        l’exposition aux
                                                        lumières artificielles
                                                        nocives, diminue la
                                                        fatigue visuelle et
                                                        limite les maux de tête
                                                        et migraines.
                                                    </li>
                                                    <li>
                                                        Toutes les 20 minutes
                                                        devant un écran, faites
                                                        une pause de 20 secondes
                                                        et concentrez-vous sur
                                                        quelque chose situé à 6
                                                        mètres.
                                                    </li>
                                                    <li>
                                                        Pensez à cligner des
                                                        yeux fréquemment,
                                                        surtout lors d'une
                                                        utilisation prolongée
                                                        des écrans.
                                                    </li>
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    </>
                                )}
                            </div>
                        </Col>
                        <Col>
                            {user?.userType == 'OPTICIAN' ? (
                                <Notification />
                            ) : (
                                ''
                            )}
                            {user?.userType === 'OPTICIAN' ? (
                                <WhatsNew />
                            ) : user?.userType === 'EYEDOCTOR' || user?.userType === 'PATIENT' ? (
                                <WhatsNew2 />
                            ) : ""}
                        </Col>
                    </Row>

                    {['OPTICIAN', 'BACKOFFICE', 'ADMIN'].includes(
                        user?.userType
                    ) && !user?.isExternal ? (
                        <OrdersCount />
                    ) : (
                        ''
                    )}
                </Container>
                <Container fluid className="footer">
                    <div>
                        <div style={{ marginBottom: '4px' }}>
                            <a
                                href="https://app.symcarelab.com/home/assets/220609MentionsLegales.pdf"
                                target="_blank"
                            >
                                {t('legalNotice')}
                            </a>{' '}
                            &{' '}
                            <a
                                href="https://app.symcarelab.com/home/assets/220906Politiquedeconfidentialit%C3%A9.pdf"
                                target="_blank"
                            >
                                {t('privacyPolicy')}
                            </a>
                        </div>
                        {user?.userType == 'EYEDOCTOR' || (
                            <div>
                                <a
                                    href={`${user?.userType == 'PATIENT' ? 'https://docs.google.com/document/d/1Z45bE8IZ3bWEd9ZzKRPSl0U6CvTVv6fHE5HgARGIOMg/edit?usp=sharing' : 'https://docs.google.com/document/d/1p6asIPqVPLP0xHjb6WhwpCcaF-8F7P2DQW_a9UNAZFo/edit?usp=sharing'}`}
                                    target="_blank"
                                >
                                    {t('faq')}
                                </a>{' '}
                                &{' '}
                                <a
                                    href={`${user?.userType == 'PATIENT' ? 'https://docs.google.com/document/d/1MDbf_Z28y-V2fPTL2mB6TY-z6vQOcOeyAlzd00Jkl2A/edit?usp=sharing' : 'https://docs.google.com/document/d/1Vyk7BW59FS8LDueLFqltvSCQ7ZlQqPxt-INb6hxce0o/edit?usp=sharing'}`}
                                    target="_blank"
                                >
                                    {t('userGuide')}
                                </a>
                            </div>
                        )}
                    </div>
                </Container>
                <ProductFruits
                    workspaceCode="prtz9Zb2NKbVbUBc"
                    language="en"
                    user={userInfo}
                />
            </div>
        </>
    );
};
export default Dashboard;
